import { RowSelectionType } from 'antd/es/table'

export const ROW_SELECTION_TYPES: RowSelectionType[] = ['checkbox', 'radio']
